import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-portal-container-view',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './portal-container-view.component.html',
    styleUrl: './portal-container-view.component.scss',
})
export class PortalContainerViewComponent {}
